<template>
  <div class="container">
    <homeHeader title="系统日志" :isShowProjectSelect="false"></homeHeader>
    <div class="main">
      <div class="card">
        <!-- 按钮组 -->
        <div class="toolbar-dv">
          <toolBarBtn :buttonVisible="buttonVisible" :parentData="this" ref="toolBarBtn"></toolBarBtn>
        </div>
        <!-- 查找面板 -->
        <div class="search-dv" v-show="searchFormVisible">
          <div class="search-container">
            <!-- 输入框 -->
            <div class="input-dv">
              <!-- 动态选渲染查询条件 -->
              <el-form
                size="mini"
                ref="SearchFormRef"
                @keyup.enter.native="sureSearch"
                :model="searchForm"
                :inline="true"
              >
                <el-form-item label="时间节点" :label-width="'120px'" prop="dateStr">
                  <el-select v-model="searchForm.dateStr" :placeholder="messageConfig.selectPlaceholder">
                    <el-option v-for="i of ComBoxItems.dateStr" :key="i + ''" :label="i" :value="i"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="人员" :label-width="'120px'" prop="person">
                  <el-input
                    v-model="searchForm.person"
                    autocomplete="off"
                    :placeholder="placeholderConfig.input"
                  ></el-input>
                </el-form-item>
                <el-form-item label="起始时间" :label-width="'120px'" prop="startTime">
                  <el-date-picker
                    type="datetime"
                    :placeholder="placeholderConfig.input"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    v-model="searchForm.startTime"
                  ></el-date-picker>
                </el-form-item>
                <el-form-item label="截止时间" :label-width="'120px'" prop="endTime">
                  <el-date-picker
                    type="datetime"
                    :placeholder="placeholderConfig.input"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    v-model="searchForm.endTime"
                  ></el-date-picker>
                </el-form-item>
              </el-form>
            </div>
            <!-- 按钮 -->
            <div class="save-button-dv">
              <!-- type="primary" -->
              <el-button icon="el-icon-search" ref="btnSearch" size="mini" @click="sureSearch">查询</el-button>
              <el-button type="info" icon="el-icon-refresh" size="mini" @click="resetSearchForm">重置 </el-button>
            </div>
          </div>
        </div>
        <div class="contentContainer" :style="{ height: contentHeight }">
          <div class="itemsContainer" v-if="logData.length > 0">
            <div
              class="itemContainer"
              :class="isToday(item.actionTime) ? 'activeItem' : ''"
              v-for="(item, index) in showLogData"
              :key="index"
            >
              <div class="itemLeft">
                <div class="itemLeftDate">
                  {{ item.actionTime }}
                  <div class="zoomBtn" @click="item.isZoom = !item.isZoom">
                    <i class="el-icon-caret-top" :class="item.isZoom ? '' : 'rotateIcon'" />
                    <!-- <i class="el-icon-caret-bottom" /> -->
                  </div>
                </div>
                <div class="itemDivider" />
              </div>
              <div class="itemRight">
                <el-timeline>
                  <el-timeline-item
                    v-for="(detailItem, detailIndex) in item.isZoom ? item.children : [item.children[0]]"
                    :key="detailIndex"
                    placement="top"
                  >
                    <span style="color: #b7999d; font-size: 14px; margin-right: 5px">{{ detailItem.logTime }}</span>
                    {{ detailItem.comment }}
                  </el-timeline-item>
                </el-timeline>
              </div>
            </div>
          </div>
          <div class="null-data" v-else>
            <el-empty description="暂无数据"></el-empty>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SystemLog',
  data() {
    return {
      id: 0,
      // 是否显示查询
      searchFormVisible: true,
      // 正常状态下，需要加上表格距离card上下的margin
      topBottomMargin: 20,
      // 按钮组的可见性
      buttonVisible: {
        add: false, // 新增按钮是否显示
        update: false, // 修改按钮
        save: false, // 保存按钮是否显示
        delete: false, // 删除按钮是否显示
        refresh: true, // 刷新数据按钮是否显示
        lock: false, // 锁定按钮是否显示
        unlock: false, // 解锁按钮是否显示
        sort: false, // 排序按钮是否显示
        search: true, // 查找按钮是否显示
        more: false // 更多按钮是否显示
      },
      // 查询条件vuepath
      searchVuePath: 'RequirementsGather',
      Authority: this.AuthorityFilter(this.$route.path),
      searchForm: {
        dateStr: '今天',
        startTime: '',
        endTime: '',
        person: ''
      },
      // 数据库数据
      logData: [],
      // 处理后的数据
      // {
      //   actionTime: 'xxxx',
      //   children: []
      // }
      showLogData: [],
      ComBoxItems: {
        dateStr: ['所有', '今天', '昨天', '本周', '上周', '本月', '上月']
      }
    }
  },
  mounted() {
    this.getData()
  },
  created() {},
  methods: {
    refresh() {
      this.getData()
    },
    async getData() {
      if (this.searchForm.startTime && this.searchForm.endTime && this.searchForm.startTime > this.searchForm.endTime) {
        this.$message.error('起始时间不能大于截至时间!')
        return
      }
      this.logData = []
      let searchForm = {
        dateStr: this.searchForm.dateStr,
        actor: this.searchForm.person,
        dateFrom: this.searchForm.startTime,
        dateTo: this.searchForm.endTime
      }
      searchForm = this.removeObjectNull(searchForm)
      const { data: res } = await this.$http.post('/Common/BActionLog/search', searchForm)
      if (!res.isSuccess) {
        this.$message.error(res.errorMessage)
        return false
      }
      this.logData = res.data
      this.handleData()
    },
    // 判断是否为今日明细
    isToday(date) {
      return this.ykDateFormat('yyyy-MM-dd', date) === this.ykDateFormat('yyyy-MM-dd', new Date())
    },
    // 处理数据操作
    handleData() {
      let showLogData = []
      for (let item of this.logData) {
        const showLogindex = showLogData.findIndex(
          sld => this.ykDateFormat('yyyy-MM-dd', sld.actionTime) === this.ykDateFormat('yyyy-MM-dd', item.actionTime)
        )
        if (showLogindex >= 0) {
          showLogData[showLogindex]['children'].push({
            logTime: this.ykDateFormat('HH:mm', item.actionTime),
            comment: item.comment
          })
        } else {
          showLogData.unshift({
            isZoom: true,
            actionTime: this.ykDateFormat('yyyy-MM-dd', item.actionTime),
            children: [
              {
                logTime: this.ykDateFormat('HH:mm', item.actionTime),
                comment: item.comment
              }
            ]
          })
        }
      }
      this.showLogData = showLogData
    },
    // 重置查找条件
    resetSearchForm() {
      this.$refs.SearchFormRef.resetFields()
      this.searchForm.Searchobject.forEach(item => {
        item.text = ''
        item.value = ''
      })
    },
    // 查找
    search() {
      this.searchFormVisible = !this.searchFormVisible
    },
    // 确认查找
    sureSearch() {
      this.getData()
    }
  },
  computed: {
    contentHeight() {
      const dynamicHeight = this.searchFormVisible ? 180 : 90
      return this.tableHeightComputed(dynamicHeight)
    }
  }
}
</script>

<style lang="less" scoped>
.main {
  width: 100%;
  margin: 0 auto;
  height: calc(100vh - @header-height);
  overflow: hidden;
}
.card {
  margin: @main-margin;
  box-shadow: #bebebe 2px 2px 10px;
  border-radius: 10px;
  overflow: hidden;
}
.search-dv {
  background-color: aquamarine;
  height: 60px;
  margin: @main-margin 10px;
}

.toolbar-dv {
  padding: 10px;
}

.table-dv {
  padding: @topBottomMargin;
}

// .approve-table-dv {
//   display: flex;
//   // 行高度，需要比 row-config 的 height 多20px，可以让内容与单元格之间有内边距
//   /deep/ .vxe-body--row {
//     height: 80px !important;
//   }
// }
// 角色名称列表
.left-role-dv {
  width: 15%;
  padding: 10px;
}
.role-list-dv {
  width: 100%;
  border-radius: 5px;
  box-shadow: #e2e2e2 0px 0px 3px;
  border: 1px solid #eeeeee;
  overflow: hidden;
  position: relative;
}

// 用户名列表
.middle-user-dv {
  width: 35%;
}
// 权限菜单列表
.menu-dv {
  width: 100%;
}

.vxe-checkbox {
  width: 15px !important;
}
// 方案容器宽度
@plan-width: 200px;

/deep/ .el-date-editor {
  .el-input__inner {
    padding-right: 15px !important;
  }
}

/deep/ .el-input__inner {
  height: 24px !important;
}

.search-container {
  height: 100%;
  width: 100%;
  display: flex;
  border-radius: 10px;
  background-color: #ffffff;
  box-shadow: #bebebe 2px 2px 10px;

  .input-dv {
    // box-sizing: border-box;
    // padding: 15px 0;
    width: calc(100% - @plan-width);
    height: 100%;
    overflow: auto;
    // background-color: #ebebeb;
    background-color: #f2f3f5;
    .fl;
    justify-content: flex-start;
  }

  .save-button-dv {
    width: @plan-width;
    height: 100%;
    background-color: #f2f3f5;
    .fl;
  }
}
.contentContainer {
  box-sizing: border-box;
  padding: 10px 0;
  .itemsContainer {
    height: 100%;
    overflow: auto;
    /** ************* 查找面板的滚动条整体样式 ************** **/
    &::-webkit-scrollbar {
      width: 9px; /*高宽分别对应横竖滚动条的尺寸*/
      height: auto;
    }

    /*查找面板的滚动条里面小方块*/
    &::-webkit-scrollbar-thumb {
      /* border-radius: 10px; */
      background-color: #ccc;
      background-color: #ccc;
      // background-image: -webkit-linear-gradient(
      //   45deg,
      //   rgba(255, 255, 255, 0.2) 25%,
      //   transparent 25%,
      //   transparent 50%,
      //   rgba(255, 255, 255, 0.2) 50%,
      //   rgba(255, 255, 255, 0.2) 75%,
      //   transparent 75%,
      //   transparent
      // );
      border-radius: 5px;
    }

    /*查找面板的滚动条里面轨道*/
    &::-webkit-scrollbar-track {
      box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.1);
      background: #ededed;
      /* border-radius: 10px; */
      border-radius: 5px;
    }
  }
}
.itemContainer {
  display: flex;
  align-items: flex-start;
  box-sizing: border-box;
  padding: 10px 20px;
  .itemLeft {
    display: flex;
    align-items: center;
    .itemLeftDate {
      width: 180px;
      box-sizing: border-box;
      padding: 23px;
      border: 2px solid #eee;
      border-radius: 5px;
      font-size: 18px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .zoomBtn {
        width: 24px;
        height: 24px;
        background-color: #daebfc;
        border-radius: 4px;
        .fl;
        i {
          color: #0c64eb;
          cursor: pointer;
          transition: all 0.5s;
        }
        .rotateIcon {
          transform: rotate(180deg);
        }
        &:hover {
          background-color: #e9f2fb;
        }
      }
    }
    .itemDivider {
      width: 20px;
      height: 2px;
      // border: 1px solid #eee;
      background-color: #eee;
    }
  }
  .itemRight {
    box-sizing: border-box;
    padding: 20px 20px 10px 20px;
    width: calc(100% - 200px);
    min-height: 74px;
    border: 2px solid #eee;
    border-radius: 5px;
    .el-timeline-item {
      padding: 0;
      padding-bottom: 10px;
    }
  }
}
.activeItem {
  .itemLeftDate {
    border: 2px solid #00a9fc !important;
  }
  .itemDivider {
    background-color: #00a9fc !important;
  }
  .itemRight {
    border: 2px solid #00a9fc !important;
  }
}
.null-data {
  height: 100%;
  .fl;
}
</style>
